module.exports = __webpack_public_path__ + "static/media/97 - James Righton - Edie.874d7827.mp3";